import Env from '../base/env';
import Component from 'gia/Component';
import gsap from 'gsap';
import easesCustom from '../fx/CustomEases';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.texts = this.DOM.view.querySelectorAll('.fxText');
    this.DOM.visual = this.DOM.view.querySelector('.fxVisual');
    this.DOM.fill = this.DOM.view.querySelector('.fxFill');

    //! Fns
    setTimeout(() => {
      this._fx()
    }, Env.timingDelayFx);
  }

  _fx()
  {
    this.animate()
    this.reveal()
  }

  animate()
  {
    this.animation = gsap.timeline()

    this.animation
    .add([
      gsap.fromTo(
        this.DOM.texts,
        {
          autoAlpha:0,
        },
        {
          autoAlpha:1,
          duration:1.5,
          ease:'cubic.inOut',
          stagger:.1
        }
      ),
    ])
    if(this.DOM.visual != null) {
      const dimensions = this.DOM.visual.getBoundingClientRect()
      gsap.set(this.DOM.fill , { width:dimensions.width + 40, height:dimensions.height + 40 })
      this.animation.add([
        gsap.fromTo(
          this.DOM.fill,
          {
            transformOrigin:'left top',
            scaleY:1
          },
          {
            scaleY:0,
            ease:'quint.inOut',
            duration:1
          }
        ),
        gsap.fromTo(
          this.DOM.visual,
          {
            scale:1.1
          },
          {
            scale:1.01,
            ease:'quint.inOut',
            duration:1
          }
        )
      ],'<+.5')
    }
  }

  reveal()
  {
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:'top 50%',
    })
  }

  unmount()
  {
    this.st.kill(true)
  }

}
